import {
  BanknotesIcon,
  CalendarIcon,
  ClockIcon,
  GlobeAltIcon,
  FilmIcon,
  LanguageIcon,
} from "@heroicons/react/24/outline";
import { useSelector } from "react-redux";
// import TrailerButton from "../../component/VideoTrailer.js";

// s// import { COUNTRIES, LANGUAGES } from "../../services/lib/constantsGeo.js";
// import { useUser } from "../../redux/slices/userSlice.js";
import { FormatTextBlock } from "../../services/utils/FormatTextBlock.js";
import { formatDate,formatRuntime } from "../../services/utils/helpers.js";

import MediaHero from "../../component/MediaHero/MediaHero.js";
// import ScorePreview from "../../../component/ScorePreview.js";
import Heading from "../../component/ui/Heading.js";
import { useResponsive } from "../../hooks/useResponsive.js";
import MediaButtons from "./MediaButtons.js";
// import MediaInList from "../../../store/features/MediaInList.js";
// import MovieCollectionLink from "../../../store/features/movieDetails/MovieCollectionLink.js";
// import { isArray } from "lodash";
import IconWrapper from "../../component/ui/IconWrapper.js";
import VideoRow from "../../component/VideoRow/VideoRow.js";
import Separator from "../../component/ui/Separator.js";

function MovieDetails({ movie }) {
  const {
    title = "Untitled",
    tagline = "",
    release_date = "",
    genres = [],
    origin_country = [],
    original_language = "en",
    runtime = 0,
    vote_average = 0,
    vote_count = 0,
    budget = 0,
    overview = "No overview available for this movie",
    description,
    rating,
    createdAt,
    categories = [],
    production_companies = [],
    belongs_to_collection = null,
    id,
  } = movie || {};
  const { name,avatar,uid } = useSelector(state => state.user);

  const { isMD,isLG } = useResponsive();

  const headingTitle = `${title}`;

  const categoryNames = Array.isArray(categories)
    ? categories.map((cat) => cat.name).join(", ")
    : "";
  const resolvedOverview = FormatTextBlock(
    description || overview || "No overview available for this movie"
  );
  return (
    <section>
      <Heading>{headingTitle}</Heading>
      <MediaHero media={movie}>
        {/* Contenuto alto: lascia spazio sotto per i bottoni assoluti */}
        <div className="relative z-10 flex h-full flex-col gap-3 pb-20">
          {/* Top content: titolo, meta e overview allineati in alto */}
          <div className="text-[2.5rem] lg:text-[3rem] xl:text-[4rem] leading-[1.1] -my-1 xl:my-0 font-heading">
            {title}
          </div>
          <div className="contents text-2xl">
            <div className="flex gap-x-8 gap-y-1 flex-wrap">
              <IconWrapper icon={<CalendarIcon />}>
                {formatDate(createdAt)}
              </IconWrapper>
              <IconWrapper icon={<GlobeAltIcon />}>{categoryNames}</IconWrapper>
            </div>
          </div>
          {!isLG && (
            <>
              <div className="max-w-[65rem] mb-4 xl:mb-6 text-[1.4rem] xl:text-[1.6rem] max-h-[24vh] overflow-y-auto pr-2">
                {resolvedOverview}
              </div>
            </>
          )}

          {/* Spazio riservato: i bottoni sono assoluti sotto */}
        </div>
        {/* Bottoni ancorati in basso al pannello */}
        <div className="absolute bottom-6 left-6 right-6 z-20">
          <MediaButtons type={"movie"} media={movie} />
        </div>
      </MediaHero>
      <Separator></Separator>
      <VideoRow title="Consigliati" api="/user/recommended" />
      <VideoRow title="Ultimi video" api="/user/getlatestvideosbynetwork" />
    </section>
  );


}

export default MovieDetails;
